import { render, staticRenderFns } from "./shopCheckout.vue?vue&type=template&id=25673b9c"
import script from "./shopCheckout.vue?vue&type=script&lang=js"
export * from "./shopCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports